<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Revisar acciones correctivas"
          directory=""
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>

      <div class="col-sm-12 mt-4">
        <div class="card card-with-shadow border-0">
          <div class="card-body">
            <legend>
              <p class="text-primary">Designaciones Equipo Evaluador</p>
            </legend>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-center" style="width: 20%">
                    TIPO
                  </th>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE ACEPTACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, i) in evalTest.evaluation_team" :key="'e' + i">
                  <td class="text-center">
                    {{ v.evaluator.evaluator_type.value }}
                  </td>
                  <td>
                    {{ v.evaluator.first_name }} {{ v.evaluator.last_name }}
                  </td>
                  <td class="text-center">
                    {{ v.updated_at | dateFormat }}
                  </td>
                  <td class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(v.evaluation_team_designation.path)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12 mt-4"
        v-if="
          evalTest.support_management_non_conformities_403_1 &&
          evalTest.support_management_non_conformities_403_1.length > 0
        "
      >
        <div class="card card-with-shadow border-0">
          <div class="card-body">
            <legend class="text-primary">
              Respaldo gestión de No Conformidades primera entrega
            </legend>
            <table class="table table-sm table-striped mt-2">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    value, key
                  ) in evalTest.support_management_non_conformities_403_1"
                  :key="key"
                >
                  <td class="align-middle">
                    <small class="text-primary">{{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}</small>
                  </td>
                  <td class="align-middle text-center">
                    <div class="mt-2">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(value.path)"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12 mt-4"
        v-if="
          evalTest.support_management_non_conformities_403_2 &&
          evalTest.support_management_non_conformities_403_2.length > 0
        "
      >
        <div class="card card-with-shadow border-0">
          <div class="card-body">
            <legend class="text-primary">
              Respaldo gestion de No Conformidades segunda entrega
            </legend>
            <table class="table table-sm table-striped mt-2">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    value, key
                  ) in evalTest.support_management_non_conformities_403_2"
                  :key="key"
                >
                  <td class="align-middle">
                    <small class="text-primary">{{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}</small>
                  </td>
                  <td class="align-middle text-center">
                    <div class="mt-2">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(value.path)"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-12">
        <app-note
          class="mt-4"
          :show-title="false"
          :notes="['Todos los campos con un (*) son obligatorios.']"
        />
      </div>

      <div class="col-sm-12" v-if="rejectCounter == 0">
        <br />
        <div class="float-left mb-3 mb-3">
          <div class="form-group text-left">
            <label>¿Se solicita al OEC Evidencias Adicionales?</label>
            <app-input
              type="radio-buttons"
              v-model="additional_evidence"
              :list="confirm"
            />
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <!-- Primera instancia -->
        <div class="row" v-if="rejectCounter == 0">
          <div class="col-sm-6">
            <div class="form-group">
              <label
                >Informe para cierre de hallazgos y decisión
                <b class="text-danger ml-2" style="font-size: 18px !important"
                  >*</b
                ></label
              >
              <app-input
                type="file"
                v-model="inputs.file_2"
                id="closing_finding_report"
                :label="
                  inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')
                "
                v-if="!inputs.closing_finding_report"
                @change="chargeFile(1)"
              />
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs.closing_finding_report.path)"
                  v-if="inputs.closing_finding_report"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="inputs.closing_finding_report = null"
                  v-if="inputs.closing_finding_report"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6" v-if="additional_evidence == 1">
            <div class="form-group">
              <label
                >Solicitud de Evidencias Adicionales
                <b class="text-danger ml-2" style="font-size: 18px !important"
                  >*</b
                ></label
              >
              <app-input
                type="file"
                v-model="inputs.file_1"
                id="request_additional_evidence"
                :label="
                  inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')
                "
                v-if="!inputs.request_additional_evidence"
                @change="chargeFile(1)"
              />
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.request_additional_evidence.path)
                  "
                  v-if="inputs.request_additional_evidence"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="inputs.request_additional_evidence = null"
                  v-if="inputs.request_additional_evidence"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Segunda instancia -->
        <!-- <div class="row" v-if="rejectCounter == 1">
          <div class="col-sm-4" v-if="additional_evidence == 1">
            <div class="form-group">
              <label
                >Solicitud de Evidencias Adicionales
                <b class="text-danger ml-2" style="font-size: 18px !important"
                  >*</b
                ></label
              >
              <app-input
                type="file"
                v-model="inputs.file_2"
                id="request_additional_evidence_2"
                :label="
                  inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')
                "
                v-if="!inputs.request_additional_evidence_2"
                @change="chargeFile(2)"
              />
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.request_additional_evidence_2.path)
                  "
                  v-if="inputs.request_additional_evidence_2"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="inputs.request_additional_evidence_2 = null"
                  v-if="inputs.request_additional_evidence_2"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-sm-12" v-if="rejectCounter == 1">
          <br />
          <div class="float-eft mb-3 mb-3">
            <div class="form-group text-left">
              <label>¿Proceder a la evaluación In Situ-Remota?</label>
              <app-input
                type="radio-buttons"
                v-model="additional_evidence"
                :list="confirm"
              />
            </div>
          </div>
        </div>

        <!-- Tercera Instancia -->
        <div class="row" v-if="rejectCounter == 1">
          <div class="col-sm-6">
            <div class="form-group">
              <label
                >Informe para cierre de hallazgos y decisión
                <b class="text-danger ml-2" style="font-size: 18px !important"
                  >*</b
                ></label
              >
              <app-input
                type="file"
                v-model="inputs.file_4"
                id="closing_finding_report_second"
                :label="
                  inputs.file_4 ? inputs.file_4.name : $t('upload_your_file')
                "
                v-if="!inputs.closing_finding_report_second"
                @change="chargeFile(1)"
              />
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.closing_finding_report_second.path)
                  "
                  v-if="inputs.closing_finding_report_second"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="inputs.closing_finding_report_second = null"
                  v-if="inputs.closing_finding_report_second"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6" v-if="additional_evidence == 0">
            <div class="form-group">
              <label
                >Justificación del rechazo de la evaluación
                <b class="text-danger">*</b></label
              >
              <app-input
                type="textarea"
                v-model="observations"
                id="justification_rejection_evaluation"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import * as actions from "../../../apiURL";
import { axiosPost } from "@/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  props: {
    evalTestId: String,
  },
  data() {
    return {
      inputs: {},
      evaluation: "",
      app_type: "",
      icon: "settings",
      tabsHorizontal: [
        // {
        //   icon: "briefcase",
        //   name: "Revisar Acciones Correctivas y Evidencias",
        //   component: "review-corrective-actions",
        //   permission: "",
        // },
        {
          icon: "briefcase",
          name: "Informe Evaluacion Documental",
          component: "attach-report-documentary",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      additional_evidence: null,
      observations: null,
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },

    rejectCounter() {
      return this.evalTest
        ? this.evalTest.corrective_actions_reject_counter
        : 0;
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    // if (this.$store.state.evaluatorReview.evalTest) {
    //   this.additional_evidence = this.$store.state.evaluatorReview.evalTest.additional_evidence;
    // }
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.DOCUMENTARY_EVALUATION}/?tab=Revisar%20Acciones%20Correctivas`;
    },
    data() {
      this.$store.dispatch("getEvalTest");
    },
    openDeleteModal() {
      if (this.additional_evidence == null) {
        this.$toastr.e(
          "Debe indicar si procede a la evaluación in situ/remota"
        );
        return;
      }

      if (
        this.rejectCounter > 0 &&
        !this.additional_evidence &&
        (this.observations == null || this.observations == "")
      ) {
        this.$toastr.e("Debe indicar las observaciones");
        return;
      }

      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      this.deleteLoader = true;
      const url = `${actions.CORRECTIVE_ACTIONS}/process/${this.evalTestId}`;
      const data = {
        additional_evidence: this.additional_evidence,
        corrective_actions_reject_counter:
          this.$store.state.evaluatorReview.evalTest
            .corrective_actions_reject_counter,
        observations: this.observations,
      };
      axiosPost(url, data)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },

    openTab(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },

    chargeFile(type) {
      this.deleteLoader = true;
      const url = `${actions.CORRECTIVE_ACTIONS}/updateCustom404`;
      let formData = new FormData();
      formData.append("evalTestId", this.evalTestId);
      if (this.inputs.file_1) {
        formData.append("file_1", this.inputs.file_1);
      }
      if (this.inputs.file_2) {
        formData.append("file_2", this.inputs.file_2);
      }
      if (this.inputs.file_3) {
        formData.append("file_3", this.inputs.file_3);
      }
      if (this.inputs.file_4) {
        formData.append("file_4", this.inputs.file_4);
      }

      axiosPost(url, formData)
        .then((res) => {
          this.evaluation = res.data.data;
          this.deleteLoader = false;
          this.afterSuccess(res.data.data);
        })
        .catch(({ error }) => {});
    },

    afterSuccess(data) {
      this.$store.state.evaluatorReview.evalTest.request_additional_evidence =
        data.request_additional_evidence;
      this.$store.state.evaluatorReview.evalTest.closing_finding_report =
        data.closing_finding_report;
      this.$store.state.evaluatorReview.evalTest.closing_finding_report_second =
        data.closing_finding_report_second;
      this.loadForm();
      this.$toastr.s(this.$t("updated_success"));
    },

    loadForm() {
      this.inputs = {
        evalTestId: this.$store.state.evaluatorReview.evalTest.id,
        request_additional_evidence:
          this.$store.state.evaluatorReview.evalTest
            .request_additional_evidence,
        closing_finding_report:
          this.$store.state.evaluatorReview.evalTest.closing_finding_report,
        closing_finding_report_second:
          this.$store.state.evaluatorReview.evalTest
            .closing_finding_report_second,
      };
      if (this.inputs.request_additional_evidence) {
        this.additional_evidence = 1;
      } else {
        this.additional_evidence = 0;
      }
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>
